import { render, staticRenderFns } from "./OpsRoleCard.vue?vue&type=template&id=1d0e2c2c&"
import script from "./OpsRoleCard.vue?vue&type=script&lang=js&"
export * from "./OpsRoleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d0e2c2c')) {
      api.createRecord('1d0e2c2c', component.options)
    } else {
      api.reload('1d0e2c2c', component.options)
    }
    module.hot.accept("./OpsRoleCard.vue?vue&type=template&id=1d0e2c2c&", function () {
      api.rerender('1d0e2c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/OpsRoleCard.vue"
export default component.exports